/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface DpCall
 */
export interface DpCall {
  /**
   *
   * @type {Array<any>}
   * @memberof DpCall
   */
  analyticsCategories?: Array<any>;
  /**
   *
   * @type {number}
   * @memberof DpCall
   */
  callId?: number;
  /**
   *
   * @type {string}
   * @memberof DpCall
   */
  callResult?: DpCallCallResultEnum;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  campaignId?: string | null;
  /**
   *
   * @type {number}
   * @memberof DpCall
   */
  companyId: number;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  contactId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  contactType?: string | null;
  /**
   *
   * @type {number}
   * @memberof DpCall
   */
  dateConnected?: number;
  /**
   *
   * @type {string}
   * @memberof DpCall
   */
  dateConnectedIso?: string;
  /**
   *
   * @type {number}
   * @memberof DpCall
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof DpCall
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof DpCall
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof DpCall
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  deviceType?: string | null;
  /**
   *
   * @type {string}
   * @memberof DpCall
   */
  direction?: DpCallDirectionEnum;
  /**
   *
   * @type {Array<any>}
   * @memberof DpCall
   */
  dispositions?: Array<any>;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  externalEndpoint?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  externalLegId?: string | null;
  /**
   *
   * @type {string}
   * @memberof DpCall
   */
  id: string;
  /**
   *
   * @type {Array<any>}
   * @memberof DpCall
   */
  internalLegIds?: Array<any>;
  /**
   *
   * @type {boolean | null}
   * @memberof DpCall
   */
  isRecording?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof DpCall
   */
  key: string;
  /**
   *
   * @type {number | null}
   * @memberof DpCall
   */
  machineDetectionConfidence?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  machineDetectionType?: string | null;
  /**
   *
   * @type {number | null}
   * @memberof DpCall
   */
  operatorCallId?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  operatorId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  operatorType?: string | null;
  /**
   *
   * @type {object}
   * @memberof DpCall
   */
  powerdialInfo?: object;
  /**
   *
   * @type {string}
   * @memberof DpCall
   */
  state: DpCallStateEnum;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  targetId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof DpCall
   */
  targetType?: string | null;
}

/**
 * @export
 */
export const DpCallCallResultEnum = {
  Connected: 'connected',
  Missed: 'missed',
  Voicemail: 'voicemail',
  Called: 'called',
} as const;
export type DpCallCallResultEnum =
  (typeof DpCallCallResultEnum)[keyof typeof DpCallCallResultEnum];

/**
 * @export
 */
export const DpCallDirectionEnum = {
  Inbound: 'inbound',
  Outbound: 'outbound',
} as const;
export type DpCallDirectionEnum =
  (typeof DpCallDirectionEnum)[keyof typeof DpCallDirectionEnum];

/**
 * @export
 */
export const DpCallStateEnum = {
  Preanswer: 'preanswer',
  Calling: 'calling',
  Ringing: 'ringing',
  Connected: 'connected',
  Merged: 'merged',
  Hold: 'hold',
  Queued: 'queued',
  Voicemail: 'voicemail',
  Eavesdrop: 'eavesdrop',
  Monitor: 'monitor',
  Barge: 'barge',
  Hangup: 'hangup',
  Blocked: 'blocked',
  Admin: 'admin',
  Parked: 'parked',
  Takeover: 'takeover',
  Postcall: 'postcall',
  Transcription: 'transcription',
  Recording: 'recording',
  Csat: 'csat',
  Dispositions: 'dispositions',
  Missed: 'missed',
  VoicemailUploaded: 'voicemail_uploaded',
  AdminRecording: 'admin_recording',
} as const;
export type DpCallStateEnum =
  (typeof DpCallStateEnum)[keyof typeof DpCallStateEnum];

/**
 * Check if a given object implements the DpCall interface.
 */
export function instanceOfDpCall(value: object): value is DpCall {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  if (!('state' in value) || value['state'] === undefined) return false;
  return true;
}

export function DpCallFromJSON(json: any): DpCall {
  return DpCallFromJSONTyped(json, false);
}

export function DpCallFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DpCall {
  if (json == null) {
    return json;
  }
  return {
    analyticsCategories:
      json['analytics_categories'] == null
        ? undefined
        : json['analytics_categories'],
    callId: json['call_id'] == null ? undefined : json['call_id'],
    callResult: json['call_result'] == null ? undefined : json['call_result'],
    campaignId: json['campaign_id'] == null ? undefined : json['campaign_id'],
    companyId: json['company_id'],
    contactId: json['contact_id'] == null ? undefined : json['contact_id'],
    contactType:
      json['contact_type'] == null ? undefined : json['contact_type'],
    dateConnected:
      json['date_connected'] == null ? undefined : json['date_connected'],
    dateConnectedIso:
      json['date_connected_iso'] == null
        ? undefined
        : json['date_connected_iso'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    deviceType: json['device_type'] == null ? undefined : json['device_type'],
    direction: json['direction'] == null ? undefined : json['direction'],
    dispositions:
      json['dispositions'] == null ? undefined : json['dispositions'],
    externalEndpoint:
      json['external_endpoint'] == null ? undefined : json['external_endpoint'],
    externalLegId:
      json['external_leg_id'] == null ? undefined : json['external_leg_id'],
    id: json['id'],
    internalLegIds:
      json['internal_leg_ids'] == null ? undefined : json['internal_leg_ids'],
    isRecording:
      json['is_recording'] == null ? undefined : json['is_recording'],
    key: json['key'],
    machineDetectionConfidence:
      json['machine_detection_confidence'] == null
        ? undefined
        : json['machine_detection_confidence'],
    machineDetectionType:
      json['machine_detection_type'] == null
        ? undefined
        : json['machine_detection_type'],
    operatorCallId:
      json['operator_call_id'] == null ? undefined : json['operator_call_id'],
    operatorId: json['operator_id'] == null ? undefined : json['operator_id'],
    operatorType:
      json['operator_type'] == null ? undefined : json['operator_type'],
    powerdialInfo:
      json['powerdial_info'] == null ? undefined : json['powerdial_info'],
    state: json['state'],
    targetId: json['target_id'] == null ? undefined : json['target_id'],
    targetType: json['target_type'] == null ? undefined : json['target_type'],
  };
}

export function DpCallToJSON(value?: DpCall | null): any {
  if (value == null) {
    return value;
  }
  return {
    analytics_categories: value['analyticsCategories'],
    call_id: value['callId'],
    call_result: value['callResult'],
    campaign_id: value['campaignId'],
    company_id: value['companyId'],
    contact_id: value['contactId'],
    contact_type: value['contactType'],
    date_connected: value['dateConnected'],
    date_connected_iso: value['dateConnectedIso'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    device_type: value['deviceType'],
    direction: value['direction'],
    dispositions: value['dispositions'],
    external_endpoint: value['externalEndpoint'],
    external_leg_id: value['externalLegId'],
    id: value['id'],
    internal_leg_ids: value['internalLegIds'],
    is_recording: value['isRecording'],
    key: value['key'],
    machine_detection_confidence: value['machineDetectionConfidence'],
    machine_detection_type: value['machineDetectionType'],
    operator_call_id: value['operatorCallId'],
    operator_id: value['operatorId'],
    operator_type: value['operatorType'],
    powerdial_info: value['powerdialInfo'],
    state: value['state'],
    target_id: value['targetId'],
    target_type: value['targetType'],
  };
}
